var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ExchangeColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,2.48608398 C75.8480225,-0.828674316 85.1519775,-0.828704834 90.8903809,2.48605347 L156.696167,40.4981079 C159.785645,42.2827148 161.211792,44.6642761 160.974609,47 L161,47 L161,82 L160.974609,82 C160.77124,84.0027161 159.345093,85.9717407 156.696167,87.5018921 L90.8903809,125.513947 C85.1519775,128.828705 75.8480225,128.828705 70.1096191,125.513947 L4.30383301,87.5018921 C1.65490723,85.9717407 0.228759766,84.0027161 0.025390625,82 L0,82 L0,47 L0.025390625,47 C-0.211791992,44.6642761 1.21435547,42.2827148 4.30383301,40.4981079 L70.1096191,2.48608398 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,0 C84.3971584,0 88.1346946,0.894265175 90.8903961,2.48606777 L156.696167,40.4980965 C159.451869,42.0898991 161,44.2488472 161,46.5 C161,48.7511451 159.451869,50.9100931 156.696167,52.5018959 L90.8903885,90.5139236 C88.1346867,92.1057265 84.3971508,93 80.5,93 C76.6028492,93 72.8653207,92.1057339 70.1096191,90.5139313 L4.30383968,52.5018997 C1.54813814,50.9100971 0,48.7511489 0,46.5 C0,44.2488511 1.54813886,42.0899031 4.30384064,40.4981003 L70.1096191,2.48606849 C72.8653209,0.894265652 76.6028569,0 80.5,0 Z M82.762,44.534 L67.5898153,53.2893526 C67.5588375,53.3072268 67.5206723,53.3071964 67.489723,53.2892729 L59.01578,48.3818022 C59.0007451,48.3730951 58.983701,48.3684554 58.9663271,48.3683404 C58.9110999,48.3679746 58.8660328,48.4124487 58.8656671,48.4676759 L58.7506679,65.8325746 L58.7585989,65.8723377 C58.7738484,65.9082 58.8094358,65.933316 58.8508571,65.9332367 L88.8947939,65.8757328 C88.9304193,65.8756646 88.9633183,65.8566485 88.9811593,65.8258122 C89.0088173,65.7780083 88.9924857,65.7168343 88.9446818,65.6891762 L81.2390133,61.230897 C81.2238698,61.2221354 81.2112899,61.209554 81.20253,61.1944095 C81.1748775,61.1466023 81.1912161,61.0854302 81.2390233,61.0577777 L101.175483,49.5261848 L82.762,44.534 Z M103.649142,22.831736 L73.6068779,22.8892331 C73.5516496,22.8893388 73.5069638,22.9341959 73.5070695,22.9894243 C73.5071379,23.0251304 73.5262392,23.0580909 73.5571856,23.0759025 L82.1656505,28.0306148 C82.2135168,28.0581648 82.2299863,28.1193018 82.2024363,28.1671681 C82.1936703,28.1823983 82.1810457,28.1950497 82.165834,28.203848 L63.3394501,39.0927774 C63.2916423,39.1204288 63.2753023,39.1816006 63.3029537,39.2294084 C63.3162437,39.2523862 63.3381242,39.2691373 63.363774,39.2759707 L82.762,44.534 L96.6916185,36.4976114 C96.7225301,36.4797754 96.7606043,36.479765 96.7915256,36.4975841 L103.484402,40.3544982 C103.532253,40.3820737 103.593399,40.3656367 103.620974,40.3177851 C103.629613,40.3027947 103.634214,40.2858195 103.634329,40.2685185 L103.749331,22.9323992 C103.749606,22.8909787 103.724658,22.8552731 103.688868,22.8398545 L103.649142,22.831736 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ExchangeColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,12.4860001 C75.8480225,9.17124176 85.1519775,9.17121124 90.8903809,12.4859695 L156.696167,50.498024 C159.785645,52.2826309 161.211792,54.6641922 160.974609,56.9999161 L161,56.9999161 L161,91.9999161 L160.974609,91.9999161 C160.77124,94.0026321 159.345093,95.9716568 156.696167,97.5018082 L90.8903809,135.513863 C85.1519775,138.828621 75.8480225,138.828621 70.1096191,135.513863 L4.30383301,97.5018082 C1.65490723,95.9716568 0.228759766,94.0026321 0.025390625,91.9999161 L0,91.9999161 L0,56.9999161 L0.025390625,56.9999161 C-0.211791992,54.6641922 1.21435547,52.2826309 4.30383301,50.498024 L70.1096191,12.4860001 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    opacity: 0.7,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.3191425,2.37914062 C75.6655252,-0.793046713 84.3337328,-0.793046951 89.6801155,2.37914014 L150.989838,38.7562447 C156.336222,41.9284327 156.336221,47.0715637 150.989838,50.2437515 L89.6801091,86.6208572 C84.3337308,89.7930422 75.6655268,89.7930529 70.3191425,86.6208649 L9.00941657,50.2437553 C3.66303344,47.071568 3.66303263,41.9284332 9.00941698,38.7562447 L70.3191425,2.37914062 Z",
    id: "Subtract",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeColor);
export default __webpack_public_path__ + "static/media/ExchangeColor.eecba65de1d77faf1e0f635f2b2ca2e3.svg";
export { ForwardRef as ReactComponent };